<template>
  <div class="px-5 sm:px-10" style="max-width: 1440px">
    <div class="mx-auto max-w-5xl">
      <div class="flex justify-end my-4">
        <button class="text-gray-400 hover:text-blue-500 flex items-center" @click="$router.back()">
          <BaseIcon name="x" size="24" />
        </button>
      </div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return { title: "Zoeken" };
  }
};
</script>